import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.scss';
import App from './App';
import Auth0ProviderWithHistory from './Auth/Auth0ProviderWithHistory';
import * as Sentry from "@sentry/react";

import { I18nextProvider } from 'react-i18next';
import i18n from './Locale/i18n';

import { Provider } from 'react-redux';
import { store } from './Store/store';

Sentry.init({
  dsn: "https://fbaa4a2d7504498b91b0a3eb3679f834@o4505269201076224.ingest.sentry.io/4505271925473280",
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <Auth0ProviderWithHistory>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </Provider>
    </Auth0ProviderWithHistory>
  </Router>
);